import Component from '@bythepixel/component-loader';

export default class Filterable extends Component {
  static selector = '[comp-filterable]'

  constructor(...args) {
    super(...args);
    this.data = this.$container.dataset;
    this.valuesSearchString = normalizeQuery(Object.values(this.data).join(' '));
    this.events();
  }

  events() {
    this.$subscribe('filter-query', ({ query }) => {
      if (this.matchFilterString(normalizeQuery(query)) || query === 'All Locations') {
        this.show();
      } else {
        this.hide();
      }
    });
  }

  hide() {
    this.$container.style.display = 'none';
    this.$publish('hide-location', this.data);
  }

  show() {
    this.$container.style.display = null;
    this.$publish('show-location', this.data);
  }

  matchFilterString(query) {
    return query.length === 0 || this.valuesSearchString.indexOf(query) >= 0;
  }
}

function normalizeQuery(s = '') {
  return s.toLowerCase();
}
